
import { useState } from 'react'
import { Icon } from '@/components/ui/icon'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip'
import { FolderItem } from './folder-item'
import { FolderGroupProps } from './types'

export const FolderGroup: React.FC<FolderGroupProps> = ({
  title,
  folders,
  categoryId,
  isUpdating = false,
  onFolderRename,
  onFolderDelete,
  onFolderMove,
  onAddFolder,
  showAddButton = false,
  className = '',
}) => {
  const [editingFolderId, setEditingFolderId] = useState<string | null>(null)

  const handleMove = (fromIndex: number, toIndex: number) => {
    // Simple: only API call on actual drop
    if (onFolderMove) {
      onFolderMove(fromIndex, toIndex, categoryId)
    }
  }

  return (
    <div className={`flex flex-col ${className}`}>
        <div className="group hover:bg-highlight-hover -mx-1 flex items-center justify-between rounded-md px-2 py-1">
          <h3 className="text-foreground pl-1 text-xs font-semibold">
            {title}
          </h3>
          {showAddButton && onAddFolder && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="text-foreground hover:text-foreground hover:bg-muted h-6 w-6 p-0 opacity-0 group-hover:opacity-100"
                    onClick={() => onAddFolder(categoryId)}
                  >
                    <Icon name="plus" className="h-3.5 w-3.5" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                  New Folder
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        <ul className="flex flex-col gap-0 text-xs">
          {folders.map((folder, index) => (
            <FolderItem
              key={folder.id}
              folder={folder}
              index={index}
              isEditing={editingFolderId === folder.id}
              isUpdating={isUpdating}
              onEdit={() => setEditingFolderId(folder.id)}
              onCancelEdit={() => setEditingFolderId(null)}
              onRename={(newName) => {
                onFolderRename?.(folder.id, newName, categoryId)
                setEditingFolderId(null)
              }}
              onDelete={() => onFolderDelete?.(folder.id, categoryId)}
              onMove={handleMove}
            />
          ))}
        </ul>
      </div>
  )
}
